export const WEIGHTS_LIMIS = {
  min: 0,
  max: 10,
};

export const SETTINGS_LIMITS = {
  min: 0,
  max: 1,
  step: 0.1,
};

export const SETTINGS_SPECIAL_LIMITS = {
  content_quality: {
    min: 0,
    max: 100,
    step: 5,
  },
};

export default {
  WEIGHTS_LIMIS,
  SETTINGS_LIMITS,
  SETTINGS_SPECIAL_LIMITS,
};
